import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { PATH } from '../../constants/router'
import LoadingPopup from '../../components/LoadingPopup'
import { decodeLink, buildQueryString } from '../../helper/params'

export default function AutoTrafficFineNotificationRedirectHandler() {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const rawRedirectData = urlParams.get('redirectData')
    
    if (rawRedirectData) {
      try {
        const decodedDataStr = decodeLink(String(rawRedirectData))
        const redirectDataObj = JSON.parse(decodedDataStr)

        const targetPath = redirectDataObj.redirectUrl
        const paramsObj = redirectDataObj.params || {}

        const queryString = buildQueryString(paramsObj)
        const fullUrl = `${targetPath}${queryString}`

        if (targetPath.startsWith('/')) {
          history.replace(fullUrl)
          return
        }
        if (targetPath.startsWith('http://') || targetPath.startsWith('https://')) {
          window.location.replace(fullUrl)
          return
        }
      } catch (error) {
        console.error('Error decoding redirectData:', error)
      }
    }

    // Fallback nếu lỗi hoặc không có redirectData
    history.replace(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT)
  }, [history, location.search])

  return <LoadingPopup type="full" noText />
}
